// Static navigation index for global search (menus, sub-menus & key tabs).
// `roles` mirrors the sidebar gating so users only see destinations they can open.
// `keywords` add search aliases. Some entries deep-link to a specific tab via `?tab=`.

const ALL = ['admin', 'regional_manager', 'branch_manager', 'loan_officer', 'cashier'];

export const NAV_INDEX = [
  { label: 'Dashboard', href: '/staff/dashboard', roles: ALL, keywords: 'home overview' },
  { label: 'Calendar', href: '/staff/calendar', roles: ALL },
  { label: 'Chat & Calls', href: '/staff/chat', roles: ALL, keywords: 'message conversation' },
  { label: 'Support Queue', href: '/staff/support-queue', roles: ALL },

  // Loan management
  { label: 'Loans Hub', href: '/staff/loans-hub', roles: ALL, keywords: 'loan management' },
  { label: 'Create Loan', href: '/staff/create-loan', roles: ['admin'], keywords: 'admin loan create new loan future advance moratorium' },
  { label: 'Applications', href: '/staff/applications', roles: ALL, keywords: 'loan applications' },
  { label: 'Loans', href: '/staff/loans', roles: ALL },
  { label: 'Disbursed Loans', href: '/staff/disbursed-loans', roles: ALL },
  { label: 'Loan Watchlist', href: '/staff/loan-watchlist', roles: ALL },
  { label: 'Loan Calculator', href: '/staff/loan-calculator', roles: ALL },
  { label: 'Payments', href: '/staff/payments', roles: ALL, keywords: 'repayment' },
  { label: 'Refunds', href: '/staff/refunds', roles: ALL },
  { label: 'Risk Watchlist', href: '/staff/risk-watchlist', roles: ['admin', 'regional_manager', 'branch_manager', 'loan_officer'] },
  { label: 'Fee Management', href: '/staff/fees', roles: ['admin', 'regional_manager'], keywords: 'fees' },
  { label: 'Loan Products', href: '/admin/loan-settings', roles: ['admin', 'regional_manager'] },
  { label: 'Mass Action', href: '/staff/mass-action', roles: ['admin', 'regional_manager'] },

  // Customers
  { label: 'Customers', href: '/staff/customers', roles: ALL, keywords: 'clients accounts' },
  { label: 'Potential Customers', href: '/staff/customers', roles: ALL, keywords: 'leads prospects' },
  { label: 'Blacklisted Report', href: '/staff/blacklist-report', roles: ['admin', 'regional_manager', 'branch_manager'], keywords: 'blacklist blacklisted vacate defaulter banned barred report' },

  // Reports & analytics
  { label: 'Reports', href: '/staff/reports', roles: ['admin', 'regional_manager', 'branch_manager', 'loan_officer'] },
  { label: 'Transaction Reports', href: '/staff/reports/transactions', roles: ALL },
  { label: 'Activity Logs', href: '/staff/activity-logs', roles: ['admin', 'regional_manager'], keywords: 'audit' },
  { label: 'Analytics', href: '/staff/analytics', roles: ALL },
  { label: 'Monthly Statistics', href: '/staff/reports/monthly-statistics', roles: ALL },
  { label: 'Marketing', href: '/staff/marketing', roles: ALL },

  // Staff management
  { label: 'Staff', href: '/staff/team', roles: ['admin', 'regional_manager', 'branch_manager'], keywords: 'team members' },
  { label: 'Staff Registrations', href: '/staff/team?tab=registrations', roles: ['admin', 'regional_manager', 'branch_manager'], keywords: 'pending registration approve new sign up' },
  { label: 'Recruitment', href: '/staff/recruitment', roles: ['admin', 'regional_manager'], keywords: 'hiring candidate pipeline guarantor offer' },
  { label: 'System Alerts', href: '/staff/system-alerts', roles: ['admin'] },
  { label: 'My Attendance', href: '/staff/my-attendance', roles: ALL, keywords: 'clock in out' },
  { label: 'My Leave Request', href: '/staff/my-leave', roles: ALL, keywords: 'leave holiday' },
  { label: 'Mobile Balances', href: '/staff/mobile-balances', roles: ['admin', 'regional_manager', 'branch_manager'] },
  { label: 'My Staff Loan', href: '/staff/my-loan', roles: ALL },
  { label: 'Attendance Register', href: '/staff/attendance', roles: ['admin', 'regional_manager', 'branch_manager'], keywords: 'attendance clock records' },
  { label: 'Clock-Out Gate', href: '/staff/attendance?tab=gate', roles: ['admin', 'regional_manager', 'branch_manager'], keywords: 'gate override clear outstanding marketing' },
  { label: 'Staff Loans', href: '/admin/staff-loans', roles: ['admin'] },
  { label: 'Chat File Cleanup', href: '/admin/chat-files', roles: ['admin'], keywords: 'storage files delete space' },
  { label: 'General Ledger', href: '/admin/general-ledger', roles: ['admin'], keywords: 'gl accounting' },
  { label: 'My Payslips', href: '/staff/my-payslips', roles: ALL, keywords: 'salary payslip' },
  { label: 'Payroll', href: '/admin/payroll', roles: ['admin', 'regional_manager'], keywords: 'salary' },
  { label: 'Performance Reports', href: '/admin/performance-reports', roles: ['admin'], keywords: 'kpi praise reprimand weekly monthly staff report' },

  // Account management
  { label: 'Expenses', href: '/staff/expenses', roles: ALL },
  { label: 'Transport Journal', href: '/staff/transport-journal', roles: ALL, keywords: 'trip transport' },
  { label: 'Petty Cash', href: '/staff/petty-cash', roles: ['admin', 'regional_manager', 'branch_manager'] },
  { label: 'Expense Analytics', href: '/staff/expense-analytics', roles: ['admin', 'regional_manager', 'branch_manager'] },
  { label: 'Income', href: '/staff/income', roles: ['admin'] },
  { label: 'Profit & Loss', href: '/staff/reports/profit-loss', roles: ['admin'], keywords: 'pnl' },

  // Investors
  { label: 'Investors', href: '/admin/investors', roles: ['admin', 'regional_manager'] },
  { label: 'Investment Hub', href: '/admin/investment-hub', roles: ['admin', 'regional_manager'] },
  { label: 'People', href: '/admin/people', roles: ['admin'] },

  // System management
  { label: 'Settings', href: '/staff/settings', roles: ALL },
  { label: 'Branches', href: '/staff/branches', roles: ['admin', 'regional_manager'] },
  { label: 'Admin Settings', href: '/admin/settings', roles: ['admin'] },
  { label: 'Roles & Permissions', href: '/staff/roles', roles: ['admin'] },
  { label: 'App Crash Reports', href: '/staff/app-crashes', roles: ['admin'] },
  { label: 'Appearance', href: '/admin/appearance', roles: ['admin'] },
  { label: 'Communication Roles', href: '/admin/task-roles', roles: ['admin', 'regional_manager', 'branch_manager'] },
  { label: 'Scheduled Jobs', href: '/admin/scheduled-jobs', roles: ['admin'] },
  { label: 'Data Health', href: '/admin/data-health', roles: ['admin'] },
  { label: 'Backup & Restore', href: '/admin/backups', roles: ['admin'] },
  { label: 'Email Reports', href: '/admin/scheduled-reports', roles: ['admin'] },
  { label: 'Email Templates', href: '/admin/email-templates', roles: ['admin'] },
  { label: 'Message Footers', href: '/admin/message-footers', roles: ['admin'] },
  { label: 'Security', href: '/admin/security', roles: ['admin'] },
  { label: 'Required Documents', href: '/admin/required-documents', roles: ['admin'] },
  { label: 'Registration Settings', href: '/admin/registration-settings', roles: ['admin'] },

  // Dashboard cards (searchable by the title shown on each card)
  { label: 'Total Customers', href: '/staff/customers', roles: ALL, keywords: 'card dashboard customers count' },
  { label: 'Active Loans', href: '/staff/loans?status=disbursed,active', roles: ALL, keywords: 'card dashboard active loans' },
  { label: 'Pending Apps', href: '/staff/applications', roles: ALL, keywords: 'card dashboard pending applications' },
  { label: 'Outstanding', href: '/staff/loans-hub', roles: ALL, keywords: 'card dashboard outstanding balance' },
  { label: 'Total Disbursed', href: '/staff/loans', roles: ALL, keywords: 'card dashboard disbursed' },
  { label: 'Collected', href: '/staff/payments', roles: ALL, keywords: 'card dashboard collected repayments' },
  { label: 'Total Expenses', href: '/staff/expenses', roles: ALL, keywords: 'card dashboard expenses' },
  { label: 'Pending Expenses', href: '/staff/expenses?status=pending', roles: ALL, keywords: 'card dashboard pending expenses' },
  { label: 'Collections Due', href: '/staff/loan-watchlist', roles: ALL, keywords: 'card dashboard overdue collections due' },

  // Sidebar section groups (searchable by group name)
  { label: 'Social', href: '/staff/chat', roles: ALL, keywords: 'section group chat calendar support' },
  { label: 'Loan Management', href: '/staff/loans-hub', roles: ALL, keywords: 'section group loans' },
  { label: 'System Reports', href: '/staff/reports', roles: ['admin', 'regional_manager', 'branch_manager', 'loan_officer'], keywords: 'section group reports analytics' },
  { label: 'Staff Management', href: '/staff/team', roles: ['admin', 'regional_manager', 'branch_manager'], keywords: 'section group staff team hr' },
  { label: 'Account Management', href: '/staff/expenses', roles: ALL, keywords: 'section group accounts expenses petty cash' },
  { label: 'System Management', href: '/staff/settings', roles: ALL, keywords: 'section group settings admin' },
  { label: 'Investor Management', href: '/admin/investors', roles: ['admin', 'regional_manager'], keywords: 'section group investors investment' },
];

// Deep-link route builder for DB record results.
export const routeForResult = (type, id) => {
  switch (type) {
    case 'customer': return `/staff/customers/${id}`;
    case 'application': return `/staff/applications/${id}`;
    case 'loan': return `/staff/loans/${id}`;
    case 'payment': return `/staff/payments`;
    case 'potential': return `/staff/potential-customers/${id}`;
    case 'expense': return `/staff/expenses`;
    case 'staff': return `/staff/team/${id}`;
    case 'investor': return `/admin/investors`;
    case 'branch': return `/staff/branches`;
    default: return '/staff/dashboard';
  }
};

export const TYPE_LABELS = {
  navigation: 'Navigation',
  customer: 'Customers',
  application: 'Applications',
  loan: 'Loans',
  payment: 'Payments',
  potential: 'Potential Customers',
  expense: 'Expenses',
  staff: 'Staff',
  investor: 'Investors',
  branch: 'Branches',
};
